<template>
  <ul class="mt-1.5 space-y-0.5 text-xs" style="font-family: 'IBM Plex Sans', sans-serif;">
    <li :class="lengthOk ? 'text-green-600' : 'text-gray-500'" class="flex items-center gap-1.5">
      <span aria-hidden="true">{{ lengthOk ? '✓' : '•' }}</span>
      At least 8 characters
    </li>
    <li :class="categoriesOk ? 'text-green-600' : 'text-gray-500'" class="flex items-center gap-1.5">
      <span aria-hidden="true">{{ categoriesOk ? '✓' : '•' }}</span>
      Characters from at least 3 of 4 types
      <span class="text-gray-400">({{ categoryCount }}/4: uppercase, lowercase, number, symbol)</span>
    </li>
  </ul>
</template>

<script>
// Client-side mirror of the backend policy (api/password_validation.ComplexityValidator
// + MinimumLengthValidator min_length=8). This is a guidance aid only — the backend
// remains the source of truth and enforces on submit.
export default {
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  computed: {
    lengthOk() {
      return this.password.length >= 8;
    },
    categoryCount() {
      const p = this.password;
      let count = 0;
      if (/[A-Z]/u.test(p) || /\p{Lu}/u.test(p)) count++;
      if (/[a-z]/u.test(p) || /\p{Ll}/u.test(p)) count++;
      if (/[0-9]/u.test(p)) count++;
      // "special" = any non-alphanumeric character (matches backend `not c.isalnum()`)
      if (/[^\p{L}\p{N}]/u.test(p)) count++;
      return count;
    },
    categoriesOk() {
      return this.categoryCount >= 3;
    },
  },
};
</script>
